import { useBeforeLeave, useLocation } from "@solidjs/router"
import { createEffect } from "solid-js"

const SCROLLS = new Map()

export function useScrollRestoration() {
  const location = useLocation()

  useBeforeLeave(({ from }) => {
    SCROLLS.set(from.pathname, document.documentElement.scrollTop)
  })

  createEffect(() => {
    const scroll = SCROLLS.get(location.pathname)
    if (!scroll) return

    document.documentElement.scrollTop = scroll
  })
}
